
export default "/assets/bars-3-micro.cc16bae3.svg"